import {
  TooltipContentSingleItem,
  TooltipContentSingleItemType,
} from 'ui-elements/modals/FsDefaultDialog/FsDefaultDialog.utils';
import reportLocales from 'globals/locales/report';

const { tooltipInfo } = reportLocales.incomeStability;

export const tooltipContent: TooltipContentSingleItem[] = [
  {
    type: TooltipContentSingleItemType.TEXT,
    content: tooltipInfo[0],
  },
  {
    type: TooltipContentSingleItemType.HEADLINE,
    content: tooltipInfo[1],
  },
  {
    type: TooltipContentSingleItemType.TEXT,
    content: tooltipInfo[2],
  },
  {
    type: TooltipContentSingleItemType.HEADLINE,
    content: tooltipInfo[3],
  },
  {
    type: TooltipContentSingleItemType.TEXT,
    content: tooltipInfo[4],
  },
  {
    type: TooltipContentSingleItemType.HEADLINE,
    content: tooltipInfo[5],
  },
  {
    type: TooltipContentSingleItemType.TEXT,
    content: tooltipInfo[6],
  },
];

export default {
  tooltipContent,
};
